import NoPage from "../Mycomponent/pages/login/noPage";
const PublicRoute = ({ children, isAccessable }) => {
  if (!isAccessable) return <NoPage />;
  return children;
};

export default PublicRoute;
